import { CommonRootState } from '../combineReducers';
import { NotistackSnackbar } from '../interfaces/notistackSnackbar';
import { ThunkAction } from 'redux-thunk';
import i18next from 'i18next';

export const enqueueSnackbar = (
  snackbar: NotistackSnackbar
): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  dispatch(
    enqueueSnackbarRequest({
      key: new Date().getTime() + Math.random(),
      ...snackbar
    })
  );
};

const enqueueSnackbarRequest = (payload: NotistackSnackbar) =>
  ({
    type: 'ENQUEUE_SNACKBAR',
    payload
  } as const);

export const enqueueRequestErrorSnackbar = (
  message = i18next.t('core.actions.errorProcessingRequest', 'There was an error processing your request.')
) =>
  enqueueSnackbar({
    message,
    options: {
      variant: 'error'
    }
  });

export const enqueueInformationSnackBar = (
  message = i18next.t('core.actions.errorProcessingRequest', 'Action successful'),
  persistentSnackbar = false
) =>
  enqueueSnackbar({
    message,
    options: {
      variant: 'success',
      persist: persistentSnackbar
    }
  });
export type Actions = ReturnType<typeof enqueueSnackbarRequest>;
